<template>
  <div>
    <el-select
      v-model="WeekOnMothSelected"
      placeholder="Seleccione Semana del Mes"
      @change="handleSelection"
      :clearable="true"
      size="mini"
      :disabled="disabled"
    >
      <el-option
        v-for="week in NumberofWeeksInMonth"
        :key="week"
        :value="week"
        :label="`Semana ${week}`"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: "WeeksOfMonthComponent",
  props: {
    initial: {
      type: Number,
      default: 0,
      required: false
    },
    Year: {
      type: Number,
      required: true
    },
    Month: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      WeekOnMothSelected: this.initial
    };
  },
  computed: {
    NumberofWeeksInMonth() {
      return this.getWeeksInMonth(this.Year, this.Month);
    }
  },
  methods: {
    handleSelection(week) {
      this.WeekOnMothSelected = week;
      this.$emit("change", this.WeekOnMothSelected);
    },
    getWeeksInMonth(year, month) {
      // Día inicial del mes
      // Primer día del mes
      const firstDay = new Date(year, month - 1, 1);
      // Último día del mes
      const lastDay = new Date(year, month, 0);

      // Obtener el domingo anterior o igual al primer día del mes
      const firstSunday = new Date(firstDay);
      firstSunday.setDate(firstDay.getDate() - firstDay.getDay());

      // Obtener el sábado siguiente o igual al último día del mes
      const lastSaturday = new Date(lastDay);
      lastSaturday.setDate(lastDay.getDate() + (6 - lastDay.getDay()));

      // Calcular la diferencia en días
      const diffInDays =
        Math.floor((lastSaturday - firstSunday) / (1000 * 60 * 60 * 24)) + 1;

      // Número total de semanas
      return diffInDays / 7;
    }
  },
  watch: {
    initial(newVal) {
      this.WeekOnMothSelected = newVal;
    }
  }
};
</script>

<style scoped></style>
